/**
 * Angular JS FAQ Controller
 *
 * @category Controllers
 * @package Common
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    var FaqController = function($scope){

        var _this = this;

        // Construct the FaqController
        this.construct = function(){
            _this.bindAccordion();
        };

        // Get retailers
        this.bindAccordion = function(){
            $('.question').click(function(e) {
              	e.preventDefault();

                var $this = $(this);

            	if ($this.next().hasClass('show')) {
                    $this.next().removeClass('show');
                    $this.next().slideUp(350);
            		$this.removeClass('active');
                } else {
                    $this.parent().parent().find('.answer').removeClass('show');
            		$this.parent().parent().find('.question').removeClass('active');
                    $this.parent().parent().find('.answer').slideUp(250);
                    $this.next().toggleClass('show');
                    $this.next().slideToggle(250);
            		$this.addClass('active');
                }
            });
        };

        this.construct.apply(this, arguments);

    };

    angular.module('App').controller('FaqController', FaqController);

})();
